import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Daksh Kumar',
      image: 'https://i.pinimg.com/736x/ae/0b/ae/ae0bae779c7d5de1d92cb0139d5f98f5.jpg',
      rating: 5,
      text: 'At Ghoomo India, our mission is to craft travel experiences that go beyond sightseeing. We focus on authentic cultural immersion, comfortable stays, and seamless planning so you can focus on making memories.'
    },
    {
      id: 2,
      name: 'Sarthak Bharadwaj',
      image: 'https://i.pinimg.com/736x/3e/05/97/3e05971f0906d044afe6e992856e3c33.jpg',
      rating: 5,
      text: 'Whether it’s the calm backwaters of Kerala or the royal palaces of Rajasthan, we curate every journey with handpicked hotels, expert guides, and delightful meals to ensure a truly unforgettable trip.'
    },
    {
      id: 3,
      name: 'Aryaman Gulati',
      image: 'https://i.pinimg.com/736x/84/4f/12/844f12669af5aca5a6949470a79ac5e0.jpg',
      rating: 5,
      text: 'We believe travel should be stress-free. From your first inquiry to your journey home, our team provides 24/7 support, ensuring every detail is taken care of so you can travel with complete peace of mind.'
    }
  ];

  const renderStars = (rating) => {
    return [...Array(rating)].map((_, index) => (
      <FaStar key={index} className="star" />
    ));
  };

  return (
    <section className="section testimonials">
      <div className="container">
        <div className="section-title">
          <h2 className="section-heading">Our Founders Say!!!</h2>
        </div>
        
        <div className="testimonials-container">
          <div className="testimonial-content">
            <div className="testimonial-text">
              <p>"{testimonials[activeTestimonial].text}"</p>
            </div>
            <div className="testimonial-author">
              <h3>{testimonials[activeTestimonial].name}</h3>
              <div className="rating">
                {renderStars(testimonials[activeTestimonial].rating)}
              </div>
            </div>
          </div>
          
          <div className="testimonial-avatars">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className={`avatar ${index === activeTestimonial ? 'active' : ''}`}
                onClick={() => setActiveTestimonial(index)}
              >
                <img src={testimonial.image} alt={testimonial.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;